import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Pagination, PagingResponseModel, BasicApiResponseModel} from '../../shared';
import {MembershipCardHeaderContainerModel} from '../../../../../../models/aggregates/crm/membership';
import {Core2Config} from '../../shared';
import { Observable } from 'rxjs';
import { MembershipCardCriteriaDTO } from '../../../data-transfer-objects/membership-card-dto.model'


@Injectable({
  providedIn: 'root'
})
export class MembershipCardHeaderService extends BaseApiTemplateService<MembershipCardHeaderContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/cards-hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership/cards-hdrs';
    this.httpClient = http;
  }

  public getByCriteriaEnhancement(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<MembershipCardHeaderContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query/enhancement?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MembershipCardHeaderContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getCountByCriteriaEnhancement(pagination: Pagination, visa: ApiVisa): Observable<ApiResponseModel<MembershipCardHeaderContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query/enhancement/count?' + pagination.getQueryKeyValues();
    return this.httpClient.get<ApiResponseModel<MembershipCardHeaderContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByLabelHdrCriteria(guid_label_hdr: string,pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<MembershipCardHeaderContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + `/labelHdr/${guid_label_hdr}/query?` + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MembershipCardHeaderContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaEnhancementUsingPost(dtoObject: MembershipCardCriteriaDTO, visa: ApiVisa): Observable<PagingResponseModel<MembershipCardHeaderContainerModel>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
      return this.httpClient.post<PagingResponseModel<MembershipCardHeaderContainerModel>>(
        this.apiUrl + '/enhancement/backoffice-ep/query',
        dtoObject,
        this.getHttpHeader(visa)
      );
  }

  public getTotalRecordsByCriteria(dtoObject: MembershipCardCriteriaDTO, visa: ApiVisa): Observable<BasicApiResponseModel<number>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
      return this.httpClient.post<BasicApiResponseModel<number>>(
        this.apiUrl + '/enhancement/backoffice-ep/query/total-records',
        dtoObject,
        this.getHttpHeader(visa)
      );
  }
  
  getMembershipCardHeaderReferee(referral_code: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/referrals/referee/' + referral_code;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  getMembershipCardHeaderReferrer(login_subject_guid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/referrals/referrer/' + login_subject_guid;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }
}
